const {
  MANIFEST_EXPORT_ERROR,
  MANIFEST_EXPORT_LOADING,
  MANIFEST_EXPORT_SUCCESS,
} = require("actions/constant");

const exportVoyagePdFReducer = (state = {}, action) => {
  switch (action.type) {
    case MANIFEST_EXPORT_LOADING:
      return {
        loading: true,
        error: false,
        success: false,
        data: [],
      };
    case MANIFEST_EXPORT_ERROR:
      return {
        loading: false,
        error: true,
        success: false,
        data: [],
      };
    case MANIFEST_EXPORT_SUCCESS:
      return {
        loading: false,
        error: false,
        success: true,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default exportVoyagePdFReducer;
